import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  skillListings: [],
  error: {},
  searchvalue: "",
  filters: [],
  searchSuggestions: [],
};

const searchCandidateMarketReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_CANDIDATEMARKET_INIT:
      return {
        ...state,
        loading: action.payload,
      };
    case types.SEARCH_CANDIDATEMARKET_SUCCESS:
      return {
        ...state,
        loading: false,
        skillListings: {
          ...state.skillListings,
          skillListings: action.payload,
        },
        error: {},
      };
    case types.SEARCH_CANDIDATEMARKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.SEARCH_CANDIDATEMARKET_VALUE:
      return {
        ...state,
        searchvalue: action.payload,
      };
    case types.GET_FILTERS_SUCCESS:
      console.log("action.payload", action.payload);
      return {
        ...state,
        filters: action.payload,
      };
    case types.FETCH_SEARCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchSuggestions: {
          ...state.searchSuggestions,
          searchSuggestions: action.payload,
        },
        error: {},
      };
    case types.FETCH_SEARCH_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default searchCandidateMarketReducer;
